import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function UserBooking() {
  const [data , setData] = useState()
let navigate = useNavigate()
  
async function getApiData() {
    let response = await fetch( "/api/booking" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            // "authorization":localStorage.getItem("token")
                  }
    })

   let data = await response.json()
          
        if (data.result === "Done") {
          ; // Response JSON alag variable mein
          console.log(data.data);
           const userId = localStorage.getItem("userid"); // 🔥 current user id
            // 🔥 Filter data: remove where paymentStatus = "pending" AND paymentMode = "Net Banking"
            const filteredData = data.data.filter(item => {
               return item.user?._id === userId && !(item.paymentStatus?.toLowerCase().trim() === "pending" && item.paymentMode?.toLowerCase().trim() === "net banking");
                //  return !(item.paymentStatus?.toLowerCase().trim() === "pending" && item.paymentMode?.toLowerCase().trim() === "net banking");
            });
            //  console.log(item.paymentStatus,item.paymentMode);
             
            console.log(filteredData); // just for checking
            setData(filteredData); // ✅ Set only filtered data
        } else {
            setData([]);
        }
}




async function cancelBooking(_id) {
  if (!window.confirm("Are you sure you want to cancel this booking , Contact Our Support Team?")) return;
        navigate("/user-support")
 
}


  
  const refreshpage=()=>{
    window.location.reload();
  }
    useEffect(()=>{
              
          getApiData();
      
            } ,[])
 
  return (
  <>
    <div className="col-md-8 col-sm-8 col-12 ">
      <div className="user-booking-h2 ">
        <h2>BOOKINGS</h2> 
        <span className='user-booking-refresh' onClick={refreshpage}>REFRESH</span>
      </div>
      <div className="user-booking ">

        {data?.length > 0 ? (
          data.map((item, index) => (
            <div key={item._id} className="border rounded-lg shadow p-4 mb-4  mx-auto">
              <h2 className="text-lg font-semibold mb-1">{item.name}</h2>
              <p><strong>BookingId:</strong> {item._id}</p>
              <p><strong>TransactionId:</strong> {item.rppid}</p>
              <p><strong>Check In:</strong> {item?.checkIn}</p>
              <p><strong>Check Out:</strong> {item?.checkOut}</p>
              <p><strong>Amount:</strong> ₹{item.total}/-</p>
              <p>
                <strong>Payment Status:</strong>{" "}
                <span className={`px-2 py-1 bg-success text-light text-sm rounded`}>
                  {item.paymentStatus}
                </span>
              </p>
              <button onClick={() => cancelBooking(item._id)} className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-gray-800">
                Cancel Booking
              </button>
            </div>
            
          ))
        ) : (
   <div className="flex flex-col items-center justify-center mt-20">
  
  <h3 className="mt-6 text-2xl font-bold text-gray-700">Your booking is empty</h3>
  <p className="text-gray-500 mt-2">Looks like you haven't booked any room yet!</p>
  <Link to="/rooms" className="mt-6 px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
    Book a Room
  </Link>
</div>

        )}

      </div>
    </div>
  </>
)

}
